import { Component, OnInit, Input } from '@angular/core';
import { Schools } from 'src/app/core/models/schools';
import { UntypedFormGroup, UntypedFormControl, FormGroupDirective, NgForm, UntypedFormBuilder } from '@angular/forms';
import { Subscriptions } from '../../shared/subscriptions';
import { ErrorStateMatcher } from '@angular/material/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { SnackBarAlertsService } from 'src/app/core/services/snackbar-alerts.service';
import { SchoolsService } from 'src/app/core/services/schools.service';

/** Error when invalid control is dirty, touched, or submitted. This allows us to validate the form as the user is typing. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-school-disbursement-information',
  templateUrl: './school-disbursement-information.component.html',
  styleUrls: ['./school-disbursement-information.component.scss']
})
export class SchoolDisbursementInformationComponent implements OnInit {
  @Input() selectedSchoolId: string;

  schoolData: Schools;
  editModeOff: boolean;
  form: UntypedFormGroup;
  isServicerConfiguration = false;
  subscriptions = new Subscriptions();

  // being used for showing error while typing
  matcher = new MyErrorStateMatcher();

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthenticationService,
    private alerts: SnackBarAlertsService,
    private schoolsService: SchoolsService
  ) {
    this.isServicerConfiguration = this.authService.isServicerConfigUser();
  }

  ngOnInit(): void {
    this.schoolsService.getSchoolsById(this.selectedSchoolId).subscribe(
      data => {
        this.schoolData = data;
        this.createForm();
      },
      error => {
        console.log(error);
      }
    );
  }

  createForm() {
    this.form = this.fb.group({
      schoolName: [{ value: this.schoolData.schoolName, disabled: false }],
      schoolCode: [{ value: this.schoolData.schoolCode, disabled: false }],
      schoolType: [{ value: this.schoolData.schoolType, disabled: false }],
      opeid: [{ value: this.schoolData.opeId, disabled: false }],
      effectiveDate: [{ value: this.schoolData.titleivEligibility.effectiveDate, disabled: false }]
    });
  }
}
